import {ActionTree} from 'vuex';
import {AppState} from '@/store/app';
import {HolidaysState} from '.';
import {CREATE_HOLIDAY, DELETE_HOLIDAY, LOAD_HOLIDAYS, UPDATE_HOLIDAY} from './actionTypes';
import {ADD_TO_HOLIDAYS_CACHE, REMOVE_HOLIDAY_FROM_CACHE, SET_HOLIDAYS, UPDATE_HOLIDAY_IN_CACHE} from './mutationTypes';
import {HANDLE_SERIOUS_ERROR} from '@/store/app/actionTypes';
import {HolidayViewModel} from '@/features/bots/models/holidayViewModel';
import {botsApi} from '@/features/bots/services/bots';

export const actions: ActionTree<HolidaysState, AppState> = {

	async [LOAD_HOLIDAYS]({commit, rootState, state, dispatch}, forceLoad?: boolean) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}

		if (state.holidays.length === 0 || forceLoad) {
			const response = await botsApi.getHolidays(currentWorkspace.id);
			commit(SET_HOLIDAYS, response);
		}

		return state.holidays;
	},

	async [CREATE_HOLIDAY]({commit, rootState}, request: HolidayViewModel) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		const createdHoliday = await botsApi.createHoliday(currentWorkspace.id, request);
		commit(ADD_TO_HOLIDAYS_CACHE, createdHoliday);
		return createdHoliday;
	},

	async [UPDATE_HOLIDAY]({commit, rootState}, request: HolidayViewModel) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		const updatedHoliday = await botsApi.updateHoliday(currentWorkspace.id, request);
		commit(UPDATE_HOLIDAY_IN_CACHE, updatedHoliday);
		return updatedHoliday;
	},

	async [DELETE_HOLIDAY]({commit, rootState}, holidayId) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		await botsApi.deleteHoliday(currentWorkspace.id, holidayId);
		commit(REMOVE_HOLIDAY_FROM_CACHE, holidayId);
	},
};
